import { ShieldCheck, CalendarClock, FileCheck2, Handshake } from "lucide-react";

const REASONS = [
  {
    Icon: ShieldCheck,
    title: "Garantía y Calidad",
    desc:
      "Materiales homologados de alta gama e inspección minuciosa en cada fase de la obra.",
  },
  {
    Icon: CalendarClock,
    title: "Cumplimiento de Plazos",
    desc:
      "Planificación rigurosa para entregar cada proyecto dentro del tiempo acordado por contrato.",
  },
  {
    Icon: FileCheck2,
    title: "Presupuesto Transparente",
    desc:
      "Desglose detallado punto por punto, sin sorpresas ni costes ocultos al finalizar la obra.",
  },
  {
    Icon: Handshake,
    title: "Atención Cercana",
    desc:
      "Asesoramiento personalizado en Cunit, provincia de Tarragona y zonas limítrofes.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="ventajas"
      data-testid="whyus-section"
      className="relative py-24 lg:py-28 bg-[#0B1528] text-white overflow-hidden"
    >
      <div className="absolute inset-0 blueprint-grid opacity-40" />
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#F26522]/20 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          {/* Left */}
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/15 text-white/80 text-xs font-mono-accent uppercase tracking-[0.18em] mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-[#F26522]" />
              Por Qué Elegir Amlou
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
              4 compromisos inquebrantables{" "}
              <span className="text-[#F26522]">con cada cliente.</span>
            </h2>
            <p className="mt-5 text-slate-300 text-base sm:text-lg leading-relaxed max-w-md">
              No prometemos lo que no podemos cumplir. Trabajamos con honestidad, oficio y una
              atención directa que marca la diferencia.
            </p>

            <div className="mt-8 flex items-center gap-4 p-5 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm">
              <div className="w-14 h-14 rounded-xl bg-[#F26522] flex items-center justify-center">
                <span className="font-display font-black text-white text-2xl">A</span>
              </div>
              <div>
                <div className="font-display font-bold text-white">Amlou Construcciones</div>
                <div className="text-xs text-white/60 font-mono-accent">
                  Empresa registrada · Cunit, Tarragona
                </div>
              </div>
            </div>
          </div>

          {/* Right — reasons grid */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {REASONS.map((r, idx) => (
              <div
                key={r.title}
                data-testid={`whyus-card-${idx}`}
                className="group p-6 rounded-2xl border border-white/10 bg-white/5 hover:bg-white/10 backdrop-blur-sm transition-all hover:-translate-y-1"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-[#F26522]/15 border border-[#F26522]/30 flex items-center justify-center shrink-0 group-hover:bg-[#F26522] group-hover:border-[#F26522] transition-colors">
                    <r.Icon className="w-5 h-5 text-[#F26522] group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <h3 className="font-display text-lg font-bold text-white mb-1.5">
                      {r.title}
                    </h3>
                    <p className="text-sm text-slate-300 leading-relaxed">{r.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
